var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, OnDestroy } from '@angular/core';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../store';
import { FormGroup, FormBuilder } from '@angular/forms';
import * as MiniIBEActions from '@ibe/store/actions/mini-ibe.actions';
import { INDRAPassengerTypeService } from '@ibe.services/passenger-type.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { SESSION_VAR_KEY_MARKET, PAX_TYPE_ADULT_CODE, PAX_TYPE_CHILD_CODE, PAX_TYPE_INFANT_CODE, COUNTRY_CODE_UNITED_KINGDOM, PAX_TYPE_YOUNG_ADULT_CODE, PAX_TYPE_ADULT, PAX_TYPE_INFANT, PAX_TYPE_YOUNG_ADULT, PAX_TYPE_CHILD, SESSION_VAR_KEY_PASSENGERS, SPECIAL_CASE_REDIRECTION, SESSION_VAR_KEY_LANGUAGE, DEFAULT_LANGUAGE } from '@ibe.config';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
var INDRASelectPassengersModalComponent = /** @class */ (function (_super) {
    __extends(INDRASelectPassengersModalComponent, _super);
    function INDRASelectPassengersModalComponent(modalService, fb, store, ibeAdminService, ibeAdminConfigService, passengerTypeService) {
        var _this = _super.call(this, modalService) || this;
        _this.modalService = modalService;
        _this.fb = fb;
        _this.store = store;
        _this.ibeAdminService = ibeAdminService;
        _this.ibeAdminConfigService = ibeAdminConfigService;
        _this.passengerTypeService = passengerTypeService;
        _this.isAlive = true;
        _this.passengers = [{
                type: PAX_TYPE_ADULT,
                label: 'Search.text.passengerAdults',
                min: '1',
                max: '9',
                description: 'Search.description.passengerAdults',
                code: PAX_TYPE_ADULT_CODE,
            }, {
                type: PAX_TYPE_YOUNG_ADULT,
                label: 'Search.text.passengerYoungAdults',
                min: '0',
                max: '9',
                description: 'Search.description.passengerYoungAdults',
                code: PAX_TYPE_YOUNG_ADULT_CODE,
            },
            {
                type: PAX_TYPE_CHILD,
                label: 'Search.text.passengerChildren',
                min: '0',
                max: '9',
                description: 'Search.description.passengerChildren',
                code: PAX_TYPE_CHILD_CODE,
            }, {
                type: PAX_TYPE_INFANT,
                label: 'Search.text.passengerInfants',
                min: '0',
                max: '9',
                description: 'Search.description.passengerInfants',
                code: PAX_TYPE_INFANT_CODE,
            }];
        _this.setIncrementToDisable = {
            adults: false,
            youngAdults: false,
            children: false,
            infants: false,
        };
        _this.setDecrementToDisable = {
            adults: false,
            youngAdults: false,
            children: false,
            infants: false,
        };
        _this.passengerListPerAdult = [
            {
                children: 0,
                infants: 0,
            }
        ];
        _this.loading$ = _this.store.select(fromStore.getUserLoading);
        _this.passengers$ = _this.store.select(fromStore.getMiniIBEPassengers);
        _this.bookAwardFlights$ = _this.store.select(fromStore.getFlightsFilterBookAwardFlights);
        _this.passengerTypeStudent$ = _this.store.select(fromStore.getFlightsFilterStudentPassenger);
        _this.passengerTypeStudent = false;
        _this.searchRoute = [];
        _this.isLoading = true;
        _this.isUnitedKingdomMarket = false;
        return _this;
    }
    INDRASelectPassengersModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.data && this.data[0] && this.data[0].params) {
            this.group = this.data[0].params.group;
            this.tripType = this.data[0].params.tripType;
            this.searchRoute = this.data[0].params.searchRoute;
            this.INDRA_resetForm();
        }
        this.passengers$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.countPerPassenger = value;
                if (sessionStorage.getItem(SESSION_VAR_KEY_PASSENGERS) !== null) {
                    var sessionStoragePassenger = JSON.parse(sessionStorage.getItem(SESSION_VAR_KEY_PASSENGERS));
                    if (_this.countPerPassenger.adults != sessionStoragePassenger.adults ||
                        _this.countPerPassenger.youngAdults != sessionStoragePassenger.youngAdults ||
                        _this.countPerPassenger.children != sessionStoragePassenger.children ||
                        _this.countPerPassenger.infants != sessionStoragePassenger.infants) {
                        _this.countPerPassenger = sessionStoragePassenger;
                    }
                }
            }
        });
        this.bookAwardFlights$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.bookAwardFlights = value;
            if (_this.bookAwardFlights != _this.bookAwardsInitialValue) {
                // this.INDRA_resetForm(); -- comment out to retain selected passengers when switching commercial <-> award
                _this.INDRA_disablePassengerTypes();
            }
            _this.bookAwardsInitialValue = _this.bookAwardFlights;
        });
        this.passengerTypeStudent$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value != _this.passengerTypeStudent && value != null) {
                _this.passengerTypeStudent = value;
                _this.INDRA_resetForm();
                _this.INDRA_disablePassengerTypes();
            }
        });
        var appendedJourneyList = '=';
        if (this.tripType === 'M') {
            for (var i = 0; i < this.searchRoute.length; i++) {
                if (this.searchRoute[i]['departure'] != null && this.searchRoute[i]['arrival'] != null) {
                    if (i == 0) {
                        appendedJourneyList += this.searchRoute[i]['departure']['code'] + '&journeyList=' + this.searchRoute[i]['arrival']['code'];
                    }
                    else if (this.searchRoute[i]['departure'] && this.searchRoute[i]['arrival']) {
                        appendedJourneyList += '&journeyList=' + this.searchRoute[i]['departure']['code'] + '&journeyList=' + this.searchRoute[i]['arrival']['code'];
                    }
                    if (!this.isUnitedKingdomMarket) {
                        if (this.searchRoute[i]['departure']['location'].countryName == COUNTRY_CODE_UNITED_KINGDOM || this.searchRoute[i]['arrival']['location'].countryName == COUNTRY_CODE_UNITED_KINGDOM) {
                            this.isUnitedKingdomMarket = true;
                        }
                    }
                }
            }
        }
        else {
            // if RT/OW and has more than one searchRoute from multicity then use only index 0
            appendedJourneyList += this.searchRoute[0]['departure']['code'] + '&journeyList=' + this.searchRoute[0]['arrival']['code'];
            if (!this.isUnitedKingdomMarket) {
                this.searchRoute[0]['departure']['location'].countryName == COUNTRY_CODE_UNITED_KINGDOM || this.searchRoute[0]['arrival']['location'].countryName == COUNTRY_CODE_UNITED_KINGDOM ?
                    this.isUnitedKingdomMarket = true : this.isUnitedKingdomMarket = false;
            }
        }
        if (this.isUnitedKingdomMarket) {
            var indexADT = this.passengers.findIndex(function (x) { return x.code === PAX_TYPE_ADULT_CODE; });
            this.passengers[indexADT].min = '0';
            this.passengers[indexADT].description = this.INDRA_getTextTranslation('Search.description.UKpassengerAdults');
            this.setDecrementToDisable.adults = true;
        }
        var param = {
            market: sessionStorage.getItem(SESSION_VAR_KEY_MARKET),
            journeyList: appendedJourneyList,
            tripType: this.tripType,
            isUnitedKingdomMarket: this.isUnitedKingdomMarket
        };
        this.passengerTypeService.getAvailablePassengerTypes(param).subscribe(function (response) {
            if (response && response.data && response.status === '200') {
                if (response.data.paxTypes == null) {
                    _this.INDRA_getMockData(param);
                }
                else {
                    _this.isLoading = false;
                    _this.availablePassengerTypes = response;
                    _this.INDRA_updatePassengerTypeRules(_this.availablePassengerTypes);
                    _this.INDRA_updatePassengerList();
                }
            }
            else {
                _this.INDRA_getMockData(param);
            }
            _this.INDRA_disablePassengerTypes();
        }, function (error) {
            _this.INDRA_getMockData(param);
        });
        // this.form = this.fb.group({
        // 	adults: [this.adults, Validators.required],
        // 	youngAdults: [this.youngAdults, Validators.required],
        // 	children: [this.children, Validators.required],
        // 	infants: [this.infants, Validators.required]
        // });
        // this.onChanges();
    };
    INDRASelectPassengersModalComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    INDRASelectPassengersModalComponent.prototype.INDRA_passengersMax = function (type) {
        if (isNaN(this.INDRA_passengersTotal())) {
            return this.totalMaxPassengers;
        }
        else {
            return this.INDRA_passengersTotal() < this.totalMaxPassengers ? this.totalMaxPassengers : 0;
        }
    };
    /**
     * Compute passenger total. Used in the template to show the passenger total
     */
    INDRASelectPassengersModalComponent.prototype.INDRA_passengersTotal = function () {
        var total = 0;
        for (var type in this.group.value) {
            total += parseInt(this.group.value[type], 10);
        }
        return total;
    };
    INDRASelectPassengersModalComponent.prototype.closeModal = function () {
        if (this.data && this.data[0] && this.data[0].handleClose) {
            this.data[0].handleClose(false, this.updateTotalCountPerPassenger);
        }
        if (sessionStorage) {
            sessionStorage.setItem(SESSION_VAR_KEY_PASSENGERS, JSON.stringify(this.group.value));
        }
        this.store.dispatch(new MiniIBEActions.PutPassengers(this.group.value)); // TODO check if can be removed
        this.modalService.close();
    };
    INDRASelectPassengersModalComponent.prototype.INDRA_canShow = function (type) {
        if (type == PAX_TYPE_INFANT_CODE) {
            if (this.bookAwardFlights === true || this.passengerTypeStudent) {
                return false;
            }
        }
        else if (type == PAX_TYPE_CHILD_CODE) {
            if (this.passengerTypeStudent) {
                return false;
            }
        }
        else if (type == PAX_TYPE_YOUNG_ADULT_CODE) {
            if (!this.isUnitedKingdomMarket) {
                return false;
            }
        }
        return true;
    };
    INDRASelectPassengersModalComponent.prototype.INDRA_getTextTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    INDRASelectPassengersModalComponent.prototype.INDRA_updatePassengerTypeRules = function (passengerTypeRules) {
        this.totalMaxPassengers = passengerTypeRules.data.maxPax;
        this.maxInfantPerAdult = parseInt(passengerTypeRules.data.businessRules['MAX_INF_PER_ADT'], 10);
        this.maxChildrenPerAdult = parseInt(passengerTypeRules.data.businessRules['MAX_CHD_PER_ADT'], 10);
        this.maxChildrenPerAdultWithInfant = parseInt(passengerTypeRules.data.businessRules['MAX_CHD_PER_ADT_INF'], 10);
        for (var i in this.passengers) {
            if (this.passengers[i].code == PAX_TYPE_INFANT_CODE) {
                this.passengers[i].max = passengerTypeRules.data.paxTypes[PAX_TYPE_INFANT_CODE];
            }
            else if (this.passengers[i].code == PAX_TYPE_ADULT_CODE) {
                this.passengers[i].max = passengerTypeRules.data.paxTypes[PAX_TYPE_ADULT_CODE];
            }
            else if (this.passengers[i].code == PAX_TYPE_CHILD_CODE) {
                this.passengers[i].max = passengerTypeRules.data.paxTypes[PAX_TYPE_CHILD_CODE];
            }
        }
    };
    INDRASelectPassengersModalComponent.prototype.INDRA_resetForm = function () {
        var _a;
        this.group.patchValue((_a = {},
            _a[PAX_TYPE_ADULT] = 1,
            _a[PAX_TYPE_YOUNG_ADULT] = 0,
            _a[PAX_TYPE_CHILD] = 0,
            _a[PAX_TYPE_INFANT] = 0,
            _a));
        this.passengerListPerAdult = [{
                children: 0,
                infants: 0,
            }];
        // this.INDRA_printPassengersCount();
    };
    INDRASelectPassengersModalComponent.prototype.INDRA_handleIncrement = function (passengerType) {
        var _this = this;
        var passengerList = {
            children: 0,
            infants: 0,
        };
        // add empty object into array
        if (passengerType == PAX_TYPE_ADULT) {
            this.passengerListPerAdult.push(passengerList);
            // assign one infant to one adult passenger
        }
        else if (passengerType == PAX_TYPE_INFANT) {
            this.passengerListPerAdult.find(function (item) {
                // assign one infant if the children passenger assigned to the adult passenger is below max.
                if (item.children > 0) {
                    if (item.children <= _this.maxChildrenPerAdultWithInfant && item.infants == 0) {
                        item.infants++;
                        return true;
                    }
                }
                else {
                    // assign one infant passenger if the infant passenger is below max.
                    if (item.infants < _this.maxInfantPerAdult) {
                        item.infants++;
                        return true;
                    }
                }
            });
        }
        this.INDRA_reassignPassengers();
        this.INDRA_disablePassengerTypes();
    };
    INDRASelectPassengersModalComponent.prototype.INDRA_handleDecrement = function (passengerType) {
        if (passengerType == PAX_TYPE_ADULT) {
            // remove one adult passenger if there are no child or infant passenger assigned to them.
            for (var i = 0; i <= this.passengerListPerAdult.length - 1; i++) {
                if (this.passengerListPerAdult[i].children == 0 && this.passengerListPerAdult[i].infants == 0) {
                    this.passengerListPerAdult.splice(i, 1);
                    break;
                }
            }
        }
        else if (passengerType == PAX_TYPE_INFANT) {
            // remove one infant passenger from the last entry if there are any.
            for (var i = this.passengerListPerAdult.length - 1; i >= 0; i--) {
                if (this.passengerListPerAdult[i].infants > 0) {
                    this.passengerListPerAdult[i].infants--;
                    break;
                }
            }
        }
        else if (passengerType == PAX_TYPE_CHILD) {
            var found = false;
            // remove one child passenger with one infant passenger.
            for (var i = this.passengerListPerAdult.length - 1; i >= 0; i--) {
                if (this.passengerListPerAdult[i].infants > 0 && this.passengerListPerAdult[i].children > 0) {
                    this.passengerListPerAdult[i].children--;
                    found = true;
                    break;
                }
            }
            if (!found) {
                // remove one child passenger from the last entry if there are any.
                for (var i = this.passengerListPerAdult.length - 1; i >= 0; i--) {
                    if (this.passengerListPerAdult[i].children > 0) {
                        this.passengerListPerAdult[i].children--;
                        break;
                    }
                }
            }
        }
        this.INDRA_reassignPassengers();
        this.INDRA_disablePassengerTypes();
    };
    INDRASelectPassengersModalComponent.prototype.INDRA_disablePassengerTypes = function () {
        var _this = this;
        var totalYoungAdults = this.group.value[PAX_TYPE_YOUNG_ADULT];
        var totalAdults = this.group.value[PAX_TYPE_ADULT];
        var totalInfants = this.group.value[PAX_TYPE_INFANT];
        var totalChildren = this.group.value[PAX_TYPE_CHILD];
        // check if there are adult passengers where there are no child or infant passengers assigned to them.
        var DisableAdultDecrement = this.passengerListPerAdult.find(function (item) {
            if (item.infants == 0 && item.children == 0) {
                return true;
            }
        });
        var DisableChildIncrement = this.passengerListPerAdult.find(function (item) {
            // check if max children per adult is reached
            if (item.infants >= 1) {
                if (item.children < _this.maxChildrenPerAdultWithInfant) {
                    return true;
                }
                // check if max children per adult with infant is reached
            }
            else {
                if (item.children < _this.maxChildrenPerAdult) {
                    return true;
                }
            }
        });
        var DisableInfantIncrement = this.passengerListPerAdult.find(function (item) {
            // check if max infant per adult is reached
            if (item.children == 0) {
                if (item.infants < _this.maxInfantPerAdult) {
                    return true;
                }
                // check if max infant per adult with children is reached
            }
            else {
                if (item.children <= _this.maxChildrenPerAdultWithInfant && item.infants == 0) {
                    return true;
                }
            }
        });
        if (DisableAdultDecrement) {
            this.setDecrementToDisable.adults = false;
        }
        else {
            this.setDecrementToDisable.adults = true;
        }
        if (DisableChildIncrement) {
            this.setIncrementToDisable.children = false;
        }
        else {
            this.setIncrementToDisable.children = true;
        }
        if (DisableInfantIncrement) {
            this.setIncrementToDisable.infants = false;
        }
        else {
            this.setIncrementToDisable.infants = true;
        }
        // disable child and infant increment if there are no adult passengers.
        if (this.isUnitedKingdomMarket) {
            if (totalAdults == 0 && totalAdults > 0) {
                this.setIncrementToDisable.infants = true;
                this.setIncrementToDisable.children = true;
            }
            // disable young adult decrement if there are no other passengers.
            if (totalYoungAdults == 1 && (totalInfants == 0 && totalChildren == 0 && totalAdults == 0)) {
                this.setDecrementToDisable.youngAdults = true;
            }
            else {
                this.setDecrementToDisable.youngAdults = false;
            }
            // disable adult decrement if there are no other passengers.
            if (totalAdults == 1 && (totalInfants == 0 && totalChildren == 0 && totalYoungAdults == 0)) {
                this.setDecrementToDisable.adults = true;
            }
        }
    };
    INDRASelectPassengersModalComponent.prototype.INDRA_reassignPassengers = function () {
        var _this = this;
        var totalChildren = this.group.value[PAX_TYPE_CHILD];
        var counter = 0;
        // reassign children passengers
        Object.keys(this.passengerListPerAdult).forEach(function (passenger) {
            _this.passengerListPerAdult[passenger].children = 0;
        });
        for (var x = 1; x <= totalChildren; x++) {
            for (var i = 0; i <= this.passengerListPerAdult.length - 1; i++) {
                if (this.passengerListPerAdult[i].infants == 1 && this.passengerListPerAdult[i].children < this.maxChildrenPerAdultWithInfant) {
                    this.passengerListPerAdult[i].children++;
                    counter++;
                    break;
                }
            }
        }
        totalChildren = totalChildren - counter;
        if (totalChildren != 0) {
            for (var x = 1; x <= totalChildren; x++) {
                for (var i = 0; i <= this.passengerListPerAdult.length - 1; i++) {
                    // check if max children per adult is reached
                    if (this.passengerListPerAdult[i].infants >= 1) {
                        if (this.passengerListPerAdult[i].children < this.maxChildrenPerAdultWithInfant) {
                            this.passengerListPerAdult[i].children++;
                            break;
                        }
                        // check if max children per adult with infant is reached
                    }
                    else {
                        if (this.passengerListPerAdult[i].children < this.maxChildrenPerAdult) {
                            this.passengerListPerAdult[i].children++;
                            break;
                        }
                    }
                }
            }
        }
        this.updateTotalCountPerPassenger = this.group.value;
    };
    INDRASelectPassengersModalComponent.prototype.INDRA_getMockData = function (param) {
        var _this = this;
        this.passengerTypeService.getMockPassengerTypes(param).subscribe(function (response) {
            if (response && response.data && response.status === '200') {
                _this.isLoading = false;
                _this.availablePassengerTypes = response;
                _this.INDRA_updatePassengerTypeRules(_this.availablePassengerTypes);
            }
        });
    };
    INDRASelectPassengersModalComponent.prototype.INDRA_updatePassengerList = function () {
        var _a;
        if (this.countPerPassenger.adults != this.group.value.adults ||
            this.countPerPassenger.youngAdults != this.group.value.youngAdults ||
            this.countPerPassenger.children != this.group.value.children ||
            this.countPerPassenger.infants != this.group.value.infants) {
            this.group.patchValue((_a = {},
                _a[PAX_TYPE_ADULT] = this.countPerPassenger.adults,
                _a[PAX_TYPE_YOUNG_ADULT] = this.isUnitedKingdomMarket ? this.countPerPassenger.youngAdults : 0,
                _a[PAX_TYPE_CHILD] = this.countPerPassenger.children,
                _a[PAX_TYPE_INFANT] = this.countPerPassenger.infants,
                _a));
            this.passengerListPerAdult = [{
                    children: 0,
                    infants: 0,
                }];
            if (this.countPerPassenger.adults > 1) {
                for (var i = 1; i < this.countPerPassenger.adults; i++) {
                    this.INDRA_handleIncrement(PAX_TYPE_ADULT);
                }
            }
            if (this.countPerPassenger.youngAdults > 0) {
                for (var i = 0; i < this.countPerPassenger.youngAdults; i++) {
                    this.INDRA_handleIncrement(PAX_TYPE_YOUNG_ADULT);
                }
            }
            if (this.countPerPassenger.infants > 0) {
                for (var i = 0; i < this.countPerPassenger.infants; i++) {
                    this.INDRA_handleIncrement(PAX_TYPE_INFANT);
                }
            }
            if (this.countPerPassenger.children > 0) {
                for (var i = 0; i < this.countPerPassenger.children; i++) {
                    this.INDRA_handleIncrement(PAX_TYPE_CHILD);
                }
            }
        }
        else {
            this.INDRA_reassignPassengers();
            this.INDRA_disablePassengerTypes();
        }
    };
    INDRASelectPassengersModalComponent.prototype.INDRA_openUrl = function (key) {
        var url;
        var market = sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase();
        var language = SPECIAL_CASE_REDIRECTION.includes(sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase()) ? DEFAULT_LANGUAGE : sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase();
        url = this.ibeAdminConfigService.getConfigurationValue(key);
        url = url.replace('${language}', language).replace('${market}', market);
        return window.open(url);
    };
    return INDRASelectPassengersModalComponent;
}(AbstractModalContentComponent));
export { INDRASelectPassengersModalComponent };
